<template>
  <div class="cf-page-container">
    <div class="cf-card cf-card--mobile cf-card--tablet cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-18">
      <h1 class="cf-title cf-title--1">
        Welcome!
      </h1>

      <div class="cf-flex cf-flex--column cf-flex--gap-32 cf-full-width">
        <div
          v-if="hasNotSelectedOrder && hasMultipleOrdersForTable"
          class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-center cf-flex--gap-10 cf-alt-background cf-margin-top-16"
        >
          <span class="cf-icon cf-icon--red far fa-exclamation-circle" />

          <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
            Looks like there are multiple orders open for this table. Please select your order to continue...
          </p>
        </div>

        <button
          v-if="hasMultipleOrdersForTable"
          class="cf-button cf-button--primary cf-button--lg cf-button--fill"
          type="button"
          @click="viewOpenOrdersClickHandler"
        >
          Select Order
        </button>

        <button
          :class="['cf-button cf-button--primary cf-button--lg cf-button--fill', { 'cf-button--disabled': hasNotSelectedOrder }]"
          type="button"
          @click="browseMenuClickHandler"
        >
          View Menu
        </button>

        <button
          :class="['cf-button cf-button--primary cf-button--lg cf-button--fill', { 'cf-button--disabled': hasNotSelectedOrder }]"
          class="cf-button cf-button--primary cf-button--lg cf-button--fill"
          type="button"
          @click="viewBillClickHandler"
        >
          View Bill
        </button>

        <button
          :class="['cf-button cf-button--primary cf-button--lg cf-button--fill']"
          class="cf-button cf-button--primary cf-button--lg cf-button--fill"
          type="button"
          @click="callServerClickHandler"
        >
          Call Server
        </button>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import IframeEventService from '@/services/iframe-event';


  export default {
    name: 'TableTopWelcomPage',

    computed: {
      ...mapGetters('orders', ['order', 'orders']),

      hasNotSelectedOrder() {
        return !this.order.orderId && this.hasMultipleOrdersForTable;
      },

      hasMultipleOrdersForTable() {
        return this.orders.length > 1;
      }
    },

    methods: {
      viewOpenOrdersClickHandler() {
        this.$openModal('select-table-top-device-order-modal', { orders: this.orders });
      },

      browseMenuClickHandler() {
        const routerConfig = {
          name: 'orderAtTableMenu',
          params: {
            merchantId: this.$route.params.merchantId
          }
        };

        this.$router.push(routerConfig);
      },

      viewBillClickHandler() {
        const routerPayload = {
          name: 'orderAtTableCartSummaryPage',
          params: { merchantId: this.$route.params.merchantId }
        };

        this.$router.push(routerPayload);
      },

      callServerClickHandler() {
        IframeEventService.triggerCallTableServer();
      }
    }
  };
</script>
